module.exports = __webpack_public_path__ + "img/portrait_1280.5278c3f1.webp";